import { render, staticRenderFns } from "./CarVendor.vue?vue&type=template&id=0dcdc2f1&"
import script from "./CarVendor.vue?vue&type=script&lang=js&"
export * from "./CarVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports